<div class="bg-white rounded-10">
  <div
    class="text-center font-roboto-700 text-17 mb-3 max-sm:mb-0 p-5 max-sm:text-14 max-sm:p-3"
  >
    {{ "Standing" | translate }}
  </div>
  <nz-skeleton
    [nzActive]="true"
    [nzLoading]="loader"
    *ngIf="loader"
    class="p-5"
  >
  </nz-skeleton>

  <div nz-row *ngIf="standingArray.length > 0">
    <div nz-col nzSpan="24" class="font-inter-500">
      <!-- <div class="pb-5" *ngFor="let table of standingArray.tables"> -->
      <nz-table
        class="standings-table"
        #sortTable
        [nzData]="standingArray"
        [nzShowPagination]="false"
        [nzPageSize]="standingArray.length"
        [nzScroll]="{ x: '400px' }"
      >
        <thead>
          <tr>
            <th
              class="font-inter-600 text-grey-2"
              *ngFor="let column of listOfColumn"
              [nzShowSort]="column.show"
              [nzSortFn]="column.compare"
              [nzSortPriority]="column.priority"
              nz-tooltip
              nzTooltipTitle="{{ column.tooltip }}"
              nzTooltipPlacement="top"
              [nzLeft]="column.fixed"
              [nzEllipsis]="true"
              [nzAlign]="column.align === 0 ? 'left' : 'center'"
              [nzWidth]="column.width"
            >
              {{ column.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of sortTable.data">
            <td>
              <div
                class="text-center justify-center items-center rounded-full w-[23px] max-sm:w-[18px] text-white bg-red-2"
              >
                {{ data.position }}
              </div>
            </td>
            <td
              [nzAlign]="'left'"
              class="cursor-pointer"
              nzLeft
              [ngStyle]="{
                'font-weight': data.color !== 'none' ? '900' : 'normal'
              }"
            >
              <div
                class="info-team"
                [routerLink]="[
                  '/Futbol/' +
                    utilityService.getCountry(data.country) +
                    '/team/' +
                    data.nameTeam +
                    '/' +
                    data.team_id
                ]"
              >
                <div class="flex gap-1">
                  <img
                    alt="logoTeam"
                    class="w-[20px] object-contain"
                    [src]="data.logoTeam"
                  />
                  {{ data.nameTeam }}
                </div>
              </div>
            </td>
            <td [nzAlign]="'center'" class="td-table bg-[#FFFAEC]">
              {{ data.total }}
            </td>
            <td [nzAlign]="'center'" class="td-table bg-[#ECF6EC] text-red-2">
              {{ data.won }}
            </td>
            <td [nzAlign]="'center'" class="td-table bg-[#FFF3F3] text-red-2">
              {{ data.loss }}
            </td>
            <td [nzAlign]="'center'" class="td-table">
              {{ data.scored }}
            </td>
            <td [nzAlign]="'center'" class="td-table" [width]="'30px'">
              {{ data.points }}
            </td>
          </tr>
        </tbody>
      </nz-table>
      <!-- </div> -->
    </div>
  </div>
  <div
    class="font-roboto-700 text-blue-o-50 text-center pb-5"
    *ngIf="standingArray.length <= 0 && !loader"
  >
    {{ "NotAvalaibleInformation" | translate }}
  </div>
</div>
